import React from 'react'
import { useBrandingColors } from 'hooks/useBrandingColors'

export const IconFlag = () => {
  const { backgroundStart, iconOnBackground } = useBrandingColors()

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width="69.684"
      height="75.09"
      viewBox="0 0 69.684 75.09"
    >
      <defs>
        <filter
          id="Контур_8319"
          x="0"
          y="0"
          width="69.684"
          height="75.09"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dy="3" />
          <feGaussianBlur stdDeviation="3" result="blur" />
          <feFlood floodOpacity="0.161" />
          <feComposite operator="in" in2="blur" />
          <feComposite in="SourceGraphic" />
        </filter>
      </defs>
      <g id="Сгруппировать_4578" data-name="Сгруппировать 4578" transform="translate(-160 -643)">
        <g transform="matrix(1, 0, 0, 1, 160, 643)" filter="url(#Контур_8319)">
          <path
            id="Контур_8319-2"
            data-name="Контур 8319"
            d="M0,25.183c.133-2.864.067-5.662.4-8.526A10.822,10.822,0,0,1,5.662,8.464C9.326,6.132,13.123,4,16.853,1.8c4.13-2.465,8.26-2.331,12.39.067,3.331,2,6.661,4,9.992,5.929,3.93,2.331,6.262,5.729,6.395,10.325.133,5.129.067,10.325-.2,15.454a10,10,0,0,1-4.6,7.86c-4.2,2.731-8.526,5.329-12.923,7.794a10.138,10.138,0,0,1-10.192-.067C13.656,46.9,9.725,44.5,5.8,42.036A11.968,11.968,0,0,1,.133,31.645c-.067-2.132,0-4.263,0-6.461Z"
            transform="translate(9 9)"
            fill={backgroundStart}
            stroke="#fff"
            strokeWidth="1"
          />
        </g>
        <g
          id="Сгруппировать_3815"
          data-name="Сгруппировать 3815"
          transform="translate(1331.023 -77.504)"
        >
          <path
            id="Контур_7914"
            data-name="Контур 7914"
            d="M-1125.812,751.291q-3.072-6.744-6.17-13.478c-.042-.092-.1-.18-.165-.309-.109.223-.19.39-.273.555a5.74,5.74,0,0,1-2.619,2.662,9.956,9.956,0,0,1-3.937.867c-1.874.105-3.754.132-5.62.32a5.456,5.456,0,0,0-3.846,1.979,20.457,20.457,0,0,0-1.184,1.827.5.5,0,0,1-.057-.064c-.037-.049-.067-.105-.1-.154a1.9,1.9,0,0,0-1.942-.665,1.523,1.523,0,0,0-1.208,1.187,2.126,2.126,0,0,0,.141,1.558q5.18,10.982,10.351,21.967c.406.864.8,1.736,1.226,2.592a1.873,1.873,0,0,0,2.874.624,2.048,2.048,0,0,0,.363-2.313q-2.445-5.19-4.9-10.375a.686.686,0,0,1,0-.662,5.829,5.829,0,0,1,3.621-3.117,16.863,16.863,0,0,1,4.388-.526c1.327-.053,2.662-.077,3.979-.238a5.964,5.964,0,0,0,5.078-3.688.761.761,0,0,0,0-.55m-21.085-1.1a.692.692,0,0,1-.636-.419l-.8-1.868a.686.686,0,0,1-.006-.528.7.7,0,0,1,.371-.378l1.867-.8a.691.691,0,0,1,.907.364l.8,1.868a.686.686,0,0,1,.005.528.685.685,0,0,1-.369.378l-1.868.8a.694.694,0,0,1-.271.055m5.3,4.547a.687.687,0,0,1-.37.378l-1.869.8a.668.668,0,0,1-.269.055.688.688,0,0,1-.636-.419l-.8-1.867a.692.692,0,0,1,.364-.907l1.868-.8a.693.693,0,0,1,.907.364l.8,1.868a.686.686,0,0,1,.006.528m2.152-4.224-1.867.8a.693.693,0,0,1-.272.056.692.692,0,0,1-.258-.05.685.685,0,0,1-.377-.371l-.8-1.867a.692.692,0,0,1,.366-.907l1.867-.8a.686.686,0,0,1,.528-.005.686.686,0,0,1,.378.369l.8,1.868a.691.691,0,0,1-.364.907m.223-3.642a.7.7,0,0,1-.258-.05.688.688,0,0,1-.378-.371l-.8-1.867a.692.692,0,0,1,.364-.907l1.867-.8a.691.691,0,0,1,.906.364l.8,1.867a.692.692,0,0,1-.364.907l-1.868.8a.691.691,0,0,1-.271.055m5.3,4.547a.682.682,0,0,1-.369.377l-1.869.8a.694.694,0,0,1-.269.055.694.694,0,0,1-.637-.419l-.8-1.868a.686.686,0,0,1-.005-.528.686.686,0,0,1,.369-.378l1.869-.8a.692.692,0,0,1,.907.364l.8,1.867a.69.69,0,0,1,0,.53m.015-3.373a.69.69,0,0,1-.636-.419l-.8-1.868a.687.687,0,0,1-.005-.528.689.689,0,0,1,.37-.378l1.868-.8a.692.692,0,0,1,.906.364l.8,1.867a.69.69,0,0,1,.006.53.689.689,0,0,1-.37.377h0l-1.867.8a.7.7,0,0,1-.271.055m5.343,4.443a.7.7,0,0,1-.371.378l-1.867.8a.7.7,0,0,1-.271.055.691.691,0,0,1-.636-.419l-.8-1.868a.693.693,0,0,1,.364-.907l1.869-.8a.686.686,0,0,1,.528-.005.686.686,0,0,1,.378.369l.8,1.868a.686.686,0,0,1,.007.528"
            fill={iconOnBackground}
          />
        </g>
      </g>
    </svg>
  )
}
